import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { ButtonProps } from './types';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import strings from '../../resources/strings';

const DeleteButton: React.FC<ButtonProps> = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        props.action();
        setOpen(false);
    };

    return (
        <span>
            <Tooltip title={props.label || ''}>
                <IconButton
                    size={props.size || 'medium'}
                    color={props.color || 'primary'}
                    aria-label={props.label}
                    onClick={handleClickOpen}
                >
                    <DeleteIcon color="error" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle style={{ fontWeight: 'bold' }}>{strings.confirmDialog.title}</DialogTitle>
                <DialogContent>{strings.confirmDialog.text}</DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{strings.confirmDialog.buttons.no}</Button>
                    <Button onClick={handleSubmit}>{strings.confirmDialog.buttons.yes}</Button>
                </DialogActions>
            </Dialog>
        </span>
    );
};

export default DeleteButton;
